import cx from 'classnames'

import Styles from './CountIndicator.module.scss'

interface CountIndicatorProps {
  count: number | string | undefined
  className?: string
  lightColor?: boolean
}

export const CountIndicator = ({ count, className, lightColor }: CountIndicatorProps) => {
  if (!count) return <div></div>

  return <div className={cx(Styles.countIndicator, className, { [Styles.lightGray]: lightColor })}>{count}</div>
}
